
import * as Sentry from '@sentry/vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'

import AppDrawer from '@/components/AppDrawer.vue'
import AppToolbar from '@/components/AppToolbar.vue'
import authRoutes from '@/modules/auth/modules/routes'
import ToastsPopup from '@/modules/toasts/components/ToastsPopup.vue'
import type { IUser } from '@/modules/user/types'
const namespaces = {
  app: 'app',
  auth: 'auth',
  user: 'user',
  toasts: 'toasts'
}

@Component({
  components: {
    ToastsPopup,
    AppToolbar,
    AppDrawer
  }
})

export default class App extends Vue {
  @State('name', { namespace: namespaces.app }) appName?: string | null
  @State('user', { namespace: namespaces.user }) user?: IUser | null
  @State('collapsedDrawer', { namespace: namespaces.app }) collapsedDrawer!:boolean
  @State('darkMode', { namespace: namespaces.app }) darkMode!: boolean
  @Action('toggleDrawer', { namespace: namespaces.app }) toggleDrawer!: () => Promise<void>

  // mini = false
  // mini = !this.$vuetify.breakpoint.mobile

  drawer = true

  get mini () {
    return this.collapsedDrawer && !this.$vuetify.breakpoint.mobile
  }

  drawerToggle () {
    if (!this.$vuetify.breakpoint.mobile) {
      this.toggleDrawer()
      return
    }
    this.drawer = !this.drawer
    // this.mini = !this.mini
  }

  get showSubroute () {
    const res = !!this.user || ['404', ...authRoutes.flatMap((r) => r.children || r).map(({ name }) => name)].includes(this.$route.name || undefined)
    return res
  }

  @Watch('user')
  userChanged (user: IUser | null) {
    if (user) {
      Sentry.setUser({
        id: user.id?.toString(),
        email: user.email,
        username: user.firstName + ' ' + user.lastName
      })
    } else {
      Sentry.setUser(null)
    }
  }

  mounted (): void {
    this.$vuetify.theme.dark = this.darkMode
    // this.$setTheme(this.darkMode ? themes.light : themes.dark)
  }
}
